export default [
    {
        title: 'افیلیت',
        icon: 'bx bx-user',
        children: [
            {
                title: 'کاربران',
                route: { name: 'useraffiliate' },
                resource: 'OrderManager',
                action: 'show',
            },
            {
                title: 'پرداخت ها',
                route: { name: 'useraffiliatesettlement' },
                resource: 'OrderManager',
                action: 'show',
            },
        ],
    },
]